import { ROLES } from '@/modules/Auth/constants';

// Обучение
const EDUCATION = [
  {
    title: 'Ведение курсов',
    icon: 'mdi-forum',
    route: { name: 'Lead' },
    roles: [ROLES.teacher],
  },
  {
    title: 'Поиск курсов',
    icon: 'mdi-clipboard-multiple-outline',
    route: { name: 'CourseList' },
    roles: [ROLES.student, ROLES.listener, ROLES.organization, ROLES.operator, ROLES.department],
  },
  {
    title: 'Списки зачисления',
    icon: 'mdi-clipboard-list-outline',
    route: { name: 'ListEnrollments' },
    badge: { key: 'enrollment', dispatchMethod: 'messages/GET_AGREEMENT' },
    roles: [ROLES.organization, ROLES.operator, ROLES.department],
  },
  {
    title: 'Расписание',
    icon: 'mdi-calendar-month',
    route: { name: 'Schedule' },
    roles: [ROLES.teacher, ROLES.listener, ROLES.student],
  },
  // {
  //   title: 'Шаблоны заданий',
  //   icon: 'mdi-text-box-outline',
  //   route: { name: 'TaskTemplateList' },
  //   isGroup: false,
  //   roles: [ROLES.teacher, ROLES.admin],
  // },
  // {
  //   title: 'Задания',
  //   icon: 'mdi-text-box-outline',
  //   route: { name: 'TaskList' },
  //   roles: [ROLES.teacher, ROLES.admin],
  // },
  {
    title: 'Я куратор',
    icon: 'mdi-pencil-box-multiple-outline',
    route: { name: 'MyCourseList' },
    roles: [ROLES.teacher],
  },
  {
    title: 'Мои курсы',
    icon: 'mdi-head-flash',
    route: { name: 'EducationCourseList' },
    roles: [ROLES.student, ROLES.listener],
  },
  // {
  //   title: 'Создать курс',
  //   icon: 'mdi-plus',
  //   route: { name: 'CourseCreate' },
  //   roles: [ROLES.organization],
  // },
  {
    title: 'Модули',
    icon: 'mdi-view-module',
    route: { name: 'ModulesManagementLead' },
    roles: [ROLES.teacher],
  },
];

// const EDUCACTION_TEACHER = [
//   {
//     title: 'Мои курсы',
//     icon: 'mdi-head-flash',
//     route: { name: 'EducationCourseList' },
//     isGroup: false,
//   },
//   {
//     title: 'Поиск курсов',
//     icon: 'mdi-clipboard-multiple-outline',
//     route: { name: 'CourseList' },
//     isGroup: false,
//   },
// ];

// // Справочники
// const REFERENCE = [
//   {
//     title: 'Направленности',
//     icon: 'mdi-axis-arrow',
//     route: { name: 'Directions' },
//     isGroup: false,
//     roles: [ROLES.student, ROLES.listener, ROLES.organization, ROLES.admin],
//   },
//   // {
//   //   title: 'Контакты',
//   //   icon: 'mdi-phone',
//   //   route: { name: 'Contacts' },
//   //   isGroup: false,
//   //   roles: [ROLES.organization, ROLES.admin],
//   // },
//   // {
//   //   title: 'Инструкции',
//   //   icon: 'mdi-information-outline',
//   //   route: { name: 'Instructions' },
//   //   isGroup: false,
//   // },
// ];

// Ресурсы
const RESOURCES = [
  // {
  //   title: 'Наставления',
  //   icon: 'mdi-text-box-outline',
  //   route: { name: 'Mentored' },
  //   roles: [ROLES.teacher, ROLES.listener, ROLES.student],
  // },
  {
    title: 'Управление курсами',
    icon: 'mdi-pencil-box-multiple-outline',
    route: { name: 'MyCourseList' },
    roles: [ROLES.organization],
  },
  {
    title: 'Преподаватели',
    icon: 'mdi-account-tie',
    route: { name: 'TeacherList' },
    roles: [ROLES.organization, ROLES.admin],
  },
  // {
  //   title: 'Вебинары',
  //   icon: 'mdi-laptop',
  //   route: { name: 'WebinarList' },
  //   roles: [ROLES.student, ROLES.listener, ROLES.teacher, ROLES.organization, ROLES.admin],
  // },
  {
    title: 'Биржа модулей',
    icon: 'mdi-view-module',
    route: { name: 'ModulesStock' },
    roles: [ROLES.organization, ROLES.admin],
  },
  {
    title: 'Платное обучение',
    icon: 'mdi-credit-card-outline',
    route: { name: 'PaymentSystem' },
    roles: [ROLES.organization, ROLES.admin],
    badge: { key: 'agreement', dispatchMethod: 'messages/GET_ENROLLMENT' },
  },
  // {
  //   title: 'Наставничество',
  //   icon: 'mdi-text-box-outline',
  //   route: { name: 'Mentoring' },
  //   roles: [ROLES.organization, ROLES.mentor],
  // },
  {
    title: 'Инструкции',
    icon: 'mdi-information-outline',
    route: { name: 'Instructions' },
  },

  // {
  //   title: 'Заявки',
  //   icon: 'mdi-text-box-outline',
  //   route: { name: 'ExchangeRequests' },
  //   isGroup: false,
  //   roles: [ROLES.organization, ROLES.teacher, ROLES.admin],
  // },
];

// // Управление
// const MANAGEMENT = [
//   {
//     title: 'Инструменты',
//     icon: 'mdi-tools',
//     // route: { name: 'Tools' },
//     isGroup: true,
//     roles: [ROLES.teacher, ROLES.admin],
//     children: [
//       {
//         title: 'Метки',
//         icon: 'mdi-tag-multiple',
//         route: { name: 'TagList' },
//         isGroup: false,
//         roles: [ROLES.teacher, ROLES.admin],
//       },
//     ],
//   },
//   {
//     title: 'Настройки пользователя',
//     icon: 'mdi-cogs',
//     route: { name: 'UserSettings' },
//     isGroup: true,
//     children: [
//       {
//         title: 'Настройки',
//         icon: 'mdi-cogs',
//         route: { name: 'UserSettings' },
//         isGroup: false,
//         roles: [ROLES.teacher, ROLES.organization, ROLES.student, ROLES.listener, ROLES.admin],
//       },
//       {
//         title: 'Виджеты',
//         icon: 'mdi-wrench',
//         route: { name: 'UserWidget' },
//         isGroup: false,
//         roles: [ROLES.organization],
//       },
//     ],
//   },
// ];

export const NAV_ITEMS = [
  {
    category_name: 'Обучение',
    items: EDUCATION,
    roles: [ROLES.student, ROLES.listener, ROLES.admin],
  },
  {
    category_name: 'Обучить Сотрудников',
    items: EDUCATION,
    roles: [ROLES.organization, ROLES.operator, ROLES.department],
  },
  // {
  //   category_name: 'Я обучаюсь',
  //   items: EDUCACTION_TEACHER,
  //   roles: [ROLES.teacher],
  // },
  {
    category_name: 'Я преподаю',
    items: EDUCATION,
    roles: [ROLES.teacher],
  },
  {
    category_name: 'Ресурсы',
    items: RESOURCES,
  },
  // {
  //   category_name: 'Справочники',
  //   items: REFERENCE,
  // },
];

export default NAV_ITEMS;
